module.exports = __webpack_public_path__ + "static/media/pharma-integrity.9333aa72.png";